<div class="container mb-2">
  <div class="row">
    <div class="col-12">
      <h1 class="page-title">{{ "RENEW_MY_COVERAGE" | globalTranslate }}</h1>
    </div>
  </div>
  <div class="row">
    <div class="card pb-2 px-0" style="width: 100%">
      <div class="card-body">
        <div>
          <a
            class="btn ps-0 btn-link"
            [routerLink]="['/user-profile', 'benefit-dashboard']"
          >
            <i class="fa fa-arrow-left"></i>
            <span class="ps-2">{{
              "BACK_TO_DASHBOARD" | globalTranslate
            }}</span>
          </a>
        </div>
        @if (response) {
        <div class="d-none d-lg-block">
          <div class="row">
            <nh-alert type="warning" [isOpen]="renewalNudgeAlert">
              <div class="row">
                <div class="col-auto icon">
                  <img
                    src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
                    alt="warning"
                  />
                </div>
                <div class="col message">
                  <span>{{ "RENEWAL_NUDGE_WARNING" | globalTranslate }}</span>
                </div>
              </div>
            </nh-alert>
            <table class="table">
              <thead>
                <tr>
                  <th>{{ "Case" | globalTranslate }}</th>
                  <th>{{ "Due Date" | globalTranslate }}</th>
                  <th>{{ "Action" | globalTranslate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (row of this.rows; track row) {
                <tr>
                  @if (row.openRenewalSW || row.openRenewalSW === null) {
                  <td>{{ row.caseNum }}</td>
                  } @if (row.openRenewalSW) {
                  <td>{{ row.renewalDueDate | date: "MM/dd/yyyy" }}</td>
                  }
                  <td>
                    @if (row.openRenewalSW === 'Y' && !row.isRenewSsiEligble &&
                    row.hoHID === this.indivId) {
                    <button
                      class="btn btn-block btn-rbsecondary"
                      [ngClass]="{
                        'font-translate': decreaseFont(),
                        'line-ht-translate': decreaseHeight()
                      }"
                      (click)="renewalWelcomePage(row)"
                    >
                      {{ "RENEW_MY_COVERAGE" | globalTranslate }}
                    </button>
                    } @if ((row.openRenewalSW === 'N'|| row.openRenewalSW ===
                    null) && row.renewalProgress !== 'RI') {
                    <p>{{ "RENEW_MY_COVERAGE_STATIC1" | globalTranslate }}</p>
                    } @if ((row.openRenewalSW === 'N'|| row.openRenewalSW ===
                    null) && row.renewalProgress === 'RI') {
                    <p>{{ "RENEW_MY_COVERAGE_STATIC3" | globalTranslate }}</p>
                    } @if (row.openRenewalSW === 'Y' && row.isRenewSsiEligble) {
                    <p>{{ "RENEW_SSI_ELIGIBLE" | globalTranslate }}</p>
                    } @if (row.openRenewalSW === 'Y' && row.hoHID !==
                    this.indivId) {
                    <p>{{ "RENEW_MY_COVERAGE_STATIC2" | globalTranslate }}</p>
                    }
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
        } @if (response) {
        <div>
          <div class="nh-table-mobile d-lg-none">
            @if (rows.length) { @for (row of rows; track row) {
            <div>
              @if (row.openRenewalSW) {
              <div class="table-row mb-3 pb-3">
                @if (row.openRenewalSW || row.openRenewalSW === null) {
                <div class="mobile-table-header">
                  {{ "Case" | globalTranslate }}
                </div>
                }
                <hr />
                @if (row.openRenewalSW || row.openRenewalSW === null) {
                <div class="mobile-table-data">{{ row.caseNum }}</div>
                }
                <br />
                @if (row.openRenewalSW) {
                <div class="mobile-table-header">
                  {{ "Due Date" | globalTranslate }}
                </div>
                }
                <hr />
                @if (row.openRenewalSW) {
                <div class="mobile-table-data">
                  {{ row.renewalDueDate | date: "MM/dd/yyyy" }}
                </div>
                }
                <br />
                @if (row.openRenewalSW) {
                <div class="mobile-table-header">
                  {{ "Action" | globalTranslate }}
                </div>
                }
              </div>
              }
              <div class="mobile-table-data">
                @if (row.openRenewalSW === 'Y' && !row.isRenewSsiEligble &&
                row.hoHID === this.indivId) {
                <button
                  class="w-100 btn btn-block btn-rbsecondary"
                  [ngClass]="{
                    'font-translate': decreaseFont(),
                    'line-ht-translate': decreaseHeight()
                  }"
                  (click)="renewalWelcomePage(row)"
                >
                  {{ "RENEW_MY_COVERAGE" | globalTranslate }}
                </button>
                } @if ((row.openRenewalSW === 'N'|| row.openRenewalSW === null)
                && row.renewalProgress !== 'RI') {
                <p>{{ "RENEW_MY_COVERAGE_STATIC1" | globalTranslate }}</p>
                } @if ((row.openRenewalSW === 'N'|| row.openRenewalSW === null)
                && row.renewalProgress === 'RI') {
                <p>{{ "RENEW_MY_COVERAGE_STATIC3" | globalTranslate }}</p>
                } @if (row.openRenewalSW === 'Y' && row.isRenewSsiEligble) {
                <p>{{ "RENEW_SSI_ELIGIBLE" | globalTranslate }}</p>
                } @if (row.openRenewalSW === 'Y' && row.hoHID !== this.indivId)
                {
                <p>{{ "RENEW_MY_COVERAGE_STATIC2" | globalTranslate }}</p>
                }
              </div>
              <br />
              <hr />
            </div>
            } } @if (!rows.length) {
            <p class="mb-5">{{ "NO_DATA_TO_DISPLAY" | globalTranslate }}</p>
            }
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>